import { autoRegisterFeature } from '@store/features/factory';
import { payerDocsCenterFeature } from './store/feature';

autoRegisterFeature(payerDocsCenterFeature);

export * from './store';
export * from './types';

// Hooks
export * from './hooks/usePayerContracts';
export * from './hooks/useContractAnalytics';

// Page exports
export { default as PayerDocsCenterPage } from './PayerDocsCenterPage';
